
import { motion } from 'framer-motion';
import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import BlogList from '@/components/blog/BlogList';

const BlogPage = () => {
  return (
    <>
      <SeoHead
        route="/blog"
        lang="pt-BR"
        title="Blog — Johnny Vaz"
        description="Artigos sobre Inteligência Artificial, construção de produtos, estratégia de negócios e o que aprendi no caminho."
      />
      <Navbar />

      {/* Hero */}
      <section style={{ backgroundColor: '#0B0B0B', paddingTop: '7rem', paddingBottom: '4rem' }}>
        <div className="container mx-auto px-6 max-w-4xl">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1.25rem' }}>
              Blog · Johnny Vaz
            </p>
            <h1 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(3rem, 9vw, 6.5rem)', lineHeight: 0.88, letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#F2EDE3', marginBottom: '2rem' }}>
              ARTIGOS &<br />
              <span style={{ color: '#FF4500' }}>REFLEXÕES</span>
            </h1>
            <div style={{ height: '2px', backgroundColor: '#FF4500', width: '64px', marginBottom: '2rem' }} />
            <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: 'clamp(1rem, 2.2vw, 1.2rem)', lineHeight: 1.65, color: '#8C8377', maxWidth: '520px' }}>
              Inteligência Artificial, construção de produtos, estratégia de negócios
              e o que aprendo construindo na prática.
            </p>
          </motion.div>
        </div>
      </section>

      <main className="pt-0 relative">
        <BlogList />
      </main>

      <Footer />
    </>
  );
};

export default BlogPage;
